import type { Suit, TarotCard } from './types';

const SUIT_BASE_INDEX: Record<Suit, number> = {
  wands: 22,
  cups: 36,
  swords: 50,
  pentacles: 64,
};

const CARD_COUNT = 78;

function normalizeIndex(value: number, max: number): number {
  return ((value % max) + max) % max;
}

function cardIndexFromId(cardId: string): number | null {
  const majorMatch = cardId.match(/^major-(\d{2})$/);
  if (majorMatch) return normalizeIndex(Number.parseInt(majorMatch[1], 10), 22);

  const minorMatch = cardId.match(/^(wands|cups|swords|pentacles)-(\d{2})$/);
  if (minorMatch) {
    const suit = minorMatch[1] as Suit;
    const number = Number.parseInt(minorMatch[2], 10);
    return SUIT_BASE_INDEX[suit] + normalizeIndex(number - 1, 14);
  }

  const placeholderMatch = cardId.match(/^card_(\d+)$/);
  if (placeholderMatch) return normalizeIndex(Number.parseInt(placeholderMatch[1], 10), CARD_COUNT);

  return null;
}

export function getCardImageIndex(card: Pick<TarotCard, 'id' | 'arcana' | 'number' | 'suit'>): number {
  const fromId = cardIndexFromId(card.id);
  if (fromId !== null) return fromId;

  if (card.arcana === 'major' && typeof card.number === 'number') {
    return normalizeIndex(card.number, 22);
  }

  if (card.arcana === 'minor' && card.suit && typeof card.number === 'number') {
    return SUIT_BASE_INDEX[card.suit] + normalizeIndex(card.number - 1, 14);
  }

  if (typeof card.number === 'number') {
    return normalizeIndex(card.number, CARD_COUNT);
  }

  return 0;
}

export function getCardFrontImageSrc(card: Pick<TarotCard, 'id' | 'arcana' | 'number' | 'suit'>): string {
  return `/cards/fronts/${getCardImageIndex(card)}.webp`;
}
